module.exports = __webpack_public_path__ + "img/module-1.f4ca2c2.png";